<template>
    <div :class="$style.row">
        <component
            :is="i === 0 ? 'div' : ContentSection"
            v-for="(section, i) in sections"
            :key="section.title"
            :class="[$style.section, $style.column]"
        >
            <Typography
                is="h2"
                size="xs"
            >
                {{ section.title }}
            </Typography>
            <ul>
                <li
                    v-for="(item, index) in section.items"
                    :key="index"
                    :class="[$style.list, $style.column]"
                >
                    <ListItem
                        :is="BaseLink"
                        :target="item.target"
                        :externalTo="item.externalTo"
                        :iconName="item.iconName"
                        labelSize="s"
                        titleSize="m"
                        responsive
                    >
                        <template
                            v-if="item.label"
                            #label
                        >
                            {{ item.label }}
                        </template>
                        <template #title>
                            {{ item.content }}
                        </template>
                    </ListItem>
                </li>
            </ul>
        </component>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import BaseLink from '@/components_new/BaseLink.vue'
import { type IconNameType } from '@/components_new/Icon'
import ListItem from '@/components_new/ListItem/ListItem.vue'
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'
import ContentSection from '@/pages/ContactUs/components/ContentSection.vue'
import { SOCIAL_LINKS } from '@/router/navigation-constants'
import { LinkTarget } from '@/types'

type Item = {
    label?: string
    content: string
    iconName?: IconNameType
    externalTo?: string
    target?: LinkTarget
}

type Section = {
    title: string
    items: Item[]
}

const tr = useTr()

const sections = computed<Section[]>(() => [
    {
        title: tr('socials.social'),
        items: SOCIAL_LINKS(tr).map((link) => ({
            content: link.title,
            iconName: link.icon,
            externalTo: link.externalTo,
            target: link.target,
        })),
    },
    {
        title: tr('socials.email'),
        items: [
            {
                label: tr('socials.developers'),
                content: 'developer.success@playgama.com',
                externalTo: 'mailto:developer.success@playgama.com',
                target: '_blank',
            },
            {
                label: tr('socials.support'),
                content: 'support@playgama.com',
                externalTo: 'mailto:support@playgama.com',
                target: '_blank',
            },
            {
                label: tr('socials.media'),
                content: 'media@playgama.com',
                externalTo: 'mailto:media@playgama.com',
                target: '_blank',
            },
        ],
    },
])
</script>

<style module>
.row {
    flex-direction: column;
    gap: 0;
}

@media (--desktop-small-plus) {
    .row {
        display: flex;
        flex-direction: row;
        gap: var(--gap-16);
        flex-wrap: wrap;
    }

    .section.column {
        /* Removing ContentSection styles for Desktop */
        padding: 0;
        margin: 0;
        border: none;
    }
}

.column {
    display: flex;
    flex-direction: column;
}

.section {
    flex-grow: 1;
    gap: var(--gap-16);
}

.list {
    gap: var(--gap-8);
}
</style>
